import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import P404 from './P404';

const Page404 = () => {

  const uData = JSON.parse(localStorage.getItem("userData"))
  const navigate = useNavigate();


  return (
    <>
     {uData?.stripeData?.stripe_day_count > 0 ? <P404></P404> : ((uData?.stripeData?.is_trial == 1 && uData?.stripeData?.stripe_day_count == 0) ? <div className="flex items-center justify-center h-screen bg-[#49BCD2] flex-col">
        <h1 className="font-bold text-white mb-2 text-[4em]">Your trial has ended.</h1>
        <h1 onClick={()=>{navigate("/Setting/billing")}} className="text-xl text-white mt-5 border-b-2 border-solid cursor-pointer font-[700]" >See Pricing Plans.</h1>
    </div>:(uData?.stripeData?.is_trial == 3 && uData?.stripeData?.stripe_day_count == 0) ? <div className="flex items-center justify-center h-screen bg-[#49BCD2] flex-col">
        <h1 className="font-bold text-white mb-2 text-[4em]">Your Subscription has ended.</h1>
        <h1 onClick={()=>{navigate("/Setting/billing")}} className="text-xl text-white mt-5 border-b-2 border-solid cursor-pointer font-[700]" >See Pricing Plans.</h1>
    </div> : <P404></P404>)}
    </>
  )
}

export default Page404